import React from "react";
import { message } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MainPage from "../../MainPage";
import {
  apiCallback,
  statusChangeApiCallback,
} from "../../../ApiHandlers/Common";
import ListDeviceModelConfig from "./ListDeviceModelConfig";
import { EntityStatus, NavMenuItems } from "../../../Constants/Constants";
import { convertDeviceModelListToDropdown } from "../../../Helpers/DeviceModelHelpers";
import { convertDeviceModelConfigList } from "../../../Helpers/ConfigHelpers";
import DeviceModelConfigForm from "./DeviceModelConfigForm";

class DeviceModelConfig extends React.Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.configuration.icon()}
        <span>{NavMenuItems.configuration.deviceModel.label}</span>
      </>,
    ];
    this.state = {
      action: null,
      record: null,
      modelData: [],
      modelDataLoading: false,
      selectedModel: null,
      modelConfigData: [],
      modelConfigDataLoading: false,
      deleteConfigDataLoading: false,
    };
  }

  componentDidMount() {
    this.updateModelList();
  }

  updateModelList = () => {
    console.log("updateData...");
    const { history, deviceModelApi } = this.props;
    this.setState({ modelDataLoading: true });
    const errorCallback = () => {
      this.setState({ modelDataLoading: false });
      message.error("Error fetching Device Model list");
    };
    const successCallback = (data) => {
      const modelData = convertDeviceModelListToDropdown(data);
      console.log("updateData data", modelData);
      this.setState({ modelData, modelDataLoading: false });
    };
    try {
      deviceModelApi.getDeviceModels(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  };

  onModelSelect = (id) => {
    console.log("onSelect", id);
    this.setState({ selectedModel: id, modelConfigData: [] });
    id && this.updateModelConfigList(id);
  };

  updateModelConfigList = (id) => {
    const modelId = id || this.state.selectedModel;
    if (!modelId) return;
    const { history, configManagementApi } = this.props;
    this.setState({ modelConfigDataLoading: true });
    const errorCallback = () => {
      this.setState({ modelConfigDataLoading: false });
      message.error("Error fetching Device Model Config list");
    };
    const successCallback = (data) => {
      const modelConfigData = convertDeviceModelConfigList(data, modelId);
      console.log("updateData data", modelConfigData);
      this.setState({ modelConfigData, modelConfigDataLoading: false });
    };
    try {
      configManagementApi.getConfigByDeviceModelId(
        modelId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  };

  onActionClick = (action, record) => () => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateModelConfigList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    try {
      console.log("onStatusChange", status, record);
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: record.name,
        errorRollback: () => this.changeStatus(record, !status),
      });
      this.props.configManagementApi.statusUpdateDeviceModelConfig(
        record.serviceId,
        record.deviceModelId,
        { status: status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE },
        callback
      );
      this.changeStatus(record, status);
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  deleteDeviceModelConfig = (record) => {
    const { history, configManagementApi } = this.props;
    this.setState({ modelDataLoading: true });
    const errorCallback = (error) => {
      this.setState({ deleteConfigDataLoading: false });
      console.log("Error deleting config", error);
      this.setState({ modelDataLoading: false });
      message.error("Unable to delete");
    };
    const successCallback = (data) => {
      this.setState({ deleteConfigDataLoading: false });
      message.success("Config Deleted Successfully");
      this.updateModelConfigList();
    };
    try {
      this.setState({ deleteConfigDataLoading: true });
      const config = {
        config: record.config,
        clientid: this.state.selectedDeviceId,
      };
      configManagementApi.removeDeviceModelConfig(
        config,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  changeStatus = (record, status) => {
    try {
      const { configId } = record;
      const modelConfigData = [...this.state.modelConfigData];
      modelConfigData.forEach((item) => {
        if (item.configId === configId) {
          item.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
        }
      });
      this.setState({ modelConfigData });
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  render() {
    const {
      action,
      record,
      modelData,
      modelDataLoading,
      deleteConfigLoading,
      selectedModel,
      modelConfigData,
      modelConfigDataLoading,
    } = this.state;
    return (
      <MainPage>
        <div className="deviceModel-config-container">
          {!action ? (
            <ListDeviceModelConfig
              modelData={modelData}
              modelDataLoading={modelDataLoading}
              selectedModel={selectedModel}
              modelConfigData={modelConfigData}
              modelConfigDataLoading={modelConfigDataLoading}
              deleteConfigLoading={deleteConfigLoading}
              onModelSelect={this.onModelSelect}
              onActionClick={this.onActionClick}
              onStatusChange={this.onStatusChange}
              deleteDeviceModelConfig={this.deleteDeviceModelConfig}
              parentBread={this.header}
            />
          ) : (
            <DeviceModelConfigForm
              action={action}
              record={record}
              modelData={modelData}
              modelDataLoading={modelDataLoading}
              onSubmit={this.onSubmit}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          )}
        </div>
      </MainPage>
    );
  }
}

DeviceModelConfig.propTypes = {
  parentBread: PropTypes.array,

  deviceModelApi: PropTypes.object,
  configManagementApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  deviceModelApi: state.apis.deviceModelApi,
  configManagementApi: state.apis.configManagementApi,
});
const connectedDeviceModelConfig = connect(mapStateToProps)(DeviceModelConfig);
export default withRouter(connectedDeviceModelConfig);
